
global.gettext = (message, data = {}) => Object.keys(data).reduce(
    (str, key) => str.replace(new RegExp(`{{${key}}}`, 'g'), data[key]),
    message,
);


global.setTranslate = (language) => {
    if (!window?.Weglot) {
        return;
    }

    window.Weglot.switchTo(language);
};

global.getTranslationLanguages = () => new Promise((resolve) => {
    if (!window?.Weglot) {
        return;
    }

    const languages = window.Weglot.options.languages
        .map(language => language.language_to)
        .concat(window.Weglot.options.language_from)
        .map(language => ({
            value: language,
            label: window.Weglot.getLanguageName(language),
        }));

    if (languages) {
        resolve(languages);
    }
});
